var ZScoreRiskCategory;
(function (ZScoreRiskCategory) {
    ZScoreRiskCategory["Profits"] = "profits";
    ZScoreRiskCategory["Risk"] = "risk";
    ZScoreRiskCategory["Service"] = "service";
    ZScoreRiskCategory["Balanced"] = "balanced";
})(ZScoreRiskCategory || (ZScoreRiskCategory = {}));

export { ZScoreRiskCategory };
